import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type NextNumberParamsT = {
  company_id: string;
};

export type NextNumberT = {
  params: NextNumberParamsT;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  params,
  errorCallback = () => {},
  successCallback = () => {},
  resultKey = 'nextPurchaseRequestNumber',
}: NextNumberT) =>
  requestAsync({
    url: endpoints.getNextNumberUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getNextNumberUrl(params),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
